import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';
import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';

import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { prepareForm, getTemplateEvents } from './../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import moment from 'moment';

const TemplatesEdit = () => {

    let navigate = useNavigate();
    const { templatesStore } = useStores();
    const { getById, template, save, reset } = templatesStore;
    const { t, i18n } = useTranslation();

    const { id } = useParams();
    const isNew = () => id && id == "new";

    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        async function fetchMyAPI() {
            setIsLoading(true);
            getById(id).then(() => {
                setIsLoading(false);

            });
        }

        if (id == "new") {
            handleReset();
        } else {
            fetchMyAPI();
        }

    }, [getById, reset]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id"]);
            formData.event = getTemplateEvents().find(x => x.id.toString() === formData.event)?.id ?? null;
            console.log(formData)
            save(formData, () => { goToList() });
        }

        setValidated(true);
    };

    const handleReset = () => {
        reset();
        setValidated(false);
    };

    const goToList = () => {
        navigate("/administration/templates")
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Card>
                <Card.Body>
                    <Stack direction="vertical">
                        <Row>
                            <Col style={{ alignSelf: "center" }}  >
                                <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../templates")} size="small" />
                                <b>{t(isNew() ? 'newTemplate' : 'template')}  {!isNew() && `(Id: ${id})`}</b>
                            </Col>
                            <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>

                            <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                        </Row>

                        <hr />

                        <Row className="my-2">
                            <Col xs={8}>
                                <FormText hidden isNumber id="id" type="number" object={template} />
                                <FormText required label={t("title")} id="name" isLoading={isLoading} object={template} />
                            </Col>
                        </Row>

                        <Row className="my-2">


                            <Col xs={8}>


                                <FormTextArea required label={t("template")} id="text" isLoading={isLoading} object={template} />

                            </Col>
                            {!isLoading && <Col xs={4} className="my-auto" style={{ fontSize: "0.78rem", }} >
                            <Row>
                                    <Col>
                                        <Stack gap={2}>
                                            <Stack direction="vertical">
                                                <u>{`${t("dashboard")}`}</u>
                                                <u>{`${t("invoice")}`}</u>
                                                <span>#Mois#: {t("monthVariable")}</span>
                                                <span>#Ann{"\u00E9e"}#: {`${moment().format("YYYY")} ${t("yearVariable")}`}</span>
                                                <span>#Consultant Prenom#: {t("consultant")} {t("name")}</span>
                                                <span>#Consultant Nom#: {t("consultant")} {t("surname")}</span>
                                                <span>#ConsultantCode#: {`${t("consultant")} ${t("code")}`}</span>
                                                <span>#Num Facture#: {t("invoiceNumber")}</span>
                                            </Stack>
                                            <Stack direction="vertical">
                                                <u>{`${t("emailFromAdministrator")}`}</u>
                                                <span>#Message#: {t("message")}</span>
                                                <span>#Expediteur Prenom#: {`${t("sender")}`} {t("name")}</span>
                                                <span>#Expediteur Nom#: {`${t("sender")}`} {t("surname")}</span>
                                                <span>#Destinataire Prenom#: {`${t("recipient")}`} {t("name")}</span>
                                                <span>#Destinataire Nom#: {`${t("recipient")}`} {t("surname")}</span>
                                            </Stack>
                                        </Stack>
                                    </Col>

                                    <Col>
                                        <Stack gap={2}>
                                            <Stack direction="vertical">
                                                <u>{t("timesheetSent")}:</u>
                                                <u>{t("timesheetReject")}:</u>
                                                <u>{t("rejectInternalExpense")}:</u>
                                                <span>#Consultant Prenom#: {t("consultant")} {t("name")}</span>
                                                <span>#Consultant Nom#: {t("consultant")} {t("surname")}</span>
                                                <span>#ConsultantCode#: {`${t("consultant")} ${t("code")}`}</span>
                                                <span>#Validateur Prenom#: {t("validator")} {t("name")}</span>
                                                <span>#Validateur Nom#: {t("validator")} {t("surname")}</span>
                                                <span>#ValidateurCode#: {`${t("validator")} ${t("code")}`}</span>
                                                <span>#RejetRaison#: {`${t("rejectReason")}`}</span>
                                            </Stack>

                                            <Stack direction="vertical">
                                                <u>{t("recoverPassword")}:</u>                                                
                                                <span>#User Prenom#: {t("consultant")} {t("name")}</span>
                                                <span>#User Nom#: {t("consultant")} {t("surname")}</span>
                                                <span>#UserCode#: {`${t("consultant")} ${t("code")}`}</span>
                                                <span>#Code#: {`${t("code")}`}</span>
                                            </Stack>
                                        </Stack>
                                    </Col>
                               
                                </Row>
                            </Col>
                            }
                        </Row>
                        <Row className="my-2">
                            <Col xs={8}>
                                <FormText required label={t("title") + " FR"} id="nameFR" isLoading={isLoading} object={template} />
                            </Col>
                        </Row>
                        <Row className="my-2">
                            <Col xs={8}>
                                <FormTextArea required label={t("template") + " FR"} id="textFR" isLoading={isLoading} object={template} />
                            </Col>
                        </Row>
                        {/*
                             <Row className="my-2">
                                <Col xs={8}>
                                    <FormText lines={5} required label={t("invoiceHeaderText")} id="invoiceHeaderText" isLoading={isLoading} object={project} />
                                </Col>
                                {!isLoading && <Col xs={4} className="my-auto" style={{ fontSize: "0.78rem", }} >
                                    {t("variables")}:<br />
                                    #Mois#: {t("monthVariable")}<br />
                                    #Ann{"\u00E9e"}#: {`${moment().format("YYYY")} ${t("yearVariable")}`}
                                </Col>}
                            </Row>
                            */ }

                        <Row className="my-2">
                            <Col xs={8}>
                                <FormSelect label={t("templateEvent")} id="event" isLoading={isLoading} items={getTemplateEvents()} itemId="id" itemLabel="name" object={template} />
                            </Col>

                        </Row>

                    </Stack>



                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(TemplatesEdit);
